module.exports = __webpack_public_path__ + "img/IMG_1149_L.a79037f8.webp";